import { DiscountOptionsFromSubscription } from "components/common/Price/utils";

export const PriceDiscountSelector = ({
  discountOptions,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onChange,
}: {
  discountOptions: DiscountOptionsFromSubscription;
  onChange: (value: string) => void;
}) => {
  if (!discountOptions.discountOptions) {
    return null;
  }

  /* We're not displaying this selector for now; default is the only option */
  return null;

  // return (
  //   <Select
  //     onChange={e => onChange(e.target.value)}
  //     options={discountOptions.discountOptions}
  //     defaultValue={discountOptions.activeDiscountFromSubscription?.id}
  //   />
  // );
};
